import { render, staticRenderFns } from "./EmployeeVacationDayWidget.vue?vue&type=template&id=355e5d86&scoped=true&"
import script from "./EmployeeVacationDayWidget.vue?vue&type=script&lang=js&"
export * from "./EmployeeVacationDayWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e5d86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355e5d86')) {
      api.createRecord('355e5d86', component.options)
    } else {
      api.reload('355e5d86', component.options)
    }
    module.hot.accept("./EmployeeVacationDayWidget.vue?vue&type=template&id=355e5d86&scoped=true&", function () {
      api.rerender('355e5d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/widgets/EmployeeVacationDayWidget.vue"
export default component.exports